<template>
  <div>No Such Property {{ noSuchProperty }}</div>
</template>

<script>
export default {
  name: "error-no-such-property"
};
</script>
